export interface IConfig {
  appBundleIds: IAppBundleIds
  api: IApiConfig
  connectService: IConnectServiceConfig
  inmateImportModes: any,
  apiCredentialSearchUserTypes: IApiCredentialSearchUserTypes,
  featureCalling: boolean,
  eventNotification: IEventNotificationConfig
  account: IAccountConfig,
  facilityTypes: string[]
}

interface IAppBundleIds {
  messaging?:string
  info?:string
  admin?:string
  kiosk?:string
}

interface IApiCredentialSearchUserTypes {
  inmate?:string
  mobile_device?:string
  online_user?:string
  facility_user?:string
  staff_user?:string
}

interface IApiConfig {
  url:string
  client:any
}

interface IConnectServiceConfig {
  url:string
}

interface IEventNotificationConfig {
  templates: IEventNotificationTemplate
  textMessageAlertTemplateIds: {
    'Email': number,
    'Text': number,
    'Call': number
  }
}

interface IEventNotificationTemplate {
  [key: string]: object
}

interface IAccountConfig {
  invoiceFrequency:Array<number>
  unblockAmounts:Array<number>
  onlineMonthlyLimits:Array<number>
}

let inmateImportModes:any = {
  'null': 'N/A',
  'ITDS': 'ITDS',
  'Generic': 'Generic',
  'GenericNumericTransformAccount': 'GenericNumericTransformAccount',
  'JailTracker': 'JailTracker',
  'TurnKey': 'TurnKey',
  'BluHorse': 'BluHorse',
  'CPC': 'CPC'
};

let domain = window.location.host; // Contains port
let apiHost = 'https://api.reliancetelephone.com/v3';
let socket = 'https://socket.reliancetelephone.com';
let appBundleIds:IAppBundleIds = {
  'messaging': 'com.reliancetelephone.connect-messaging',
  'kiosk': 'com.reliancetelephone.connect-kiosk',
  'admin': 'com.reliancetelephone.ConnectAdmin',
  'info': 'com.reliancetelephone.ConnectInfo'
};
let apiCredentialSearchUserTypes: IApiCredentialSearchUserTypes = {
  inmate: 'Inmate',
  mobile_device: 'Mobile Device',
  online_user: 'Online User',
  facility_user: 'Facility User',
  staff_user: 'Staff User'
};
let featureCalling = true;
// Aligned with rows from tblEventNotificationActionTemplate
let textMessageAlertTemplateIds = {
  'Email': 8,
  'Text': 9,
  'Call': 10
}
let facilityTypes = [];

switch (window.location.hostname) {
  case '10.44.0.3':
    apiHost = 'http://10.44.0.3:4567'
  break;

  case 'localhost':
    socket = 'https://test.socket.reliancetelephone.com';
    apiHost = 'http://localhost:4567';

    // Aligned with rows from tblEventNotificationActionTemplate
    textMessageAlertTemplateIds = {
      'Email': 7,
      'Text': 8,
      'Call': 9
    };

    facilityTypes = ['reliance', 'amtel', 'demo'];
  break;

  case 'test.admin.cpctexting.com':
  case 'west2.test.admin.cpctexting.com.s3-website-us-west-2.amazonaws.com':
    apiHost = 'https://test.api.cpctexting.com/v3';
    socket = 'https://test.socket.cpctexting.com';
    inmateImportModes = { 'CPC': 'CPC' };
    featureCalling = false;
    apiCredentialSearchUserTypes = {
      inmate: 'Inmate',
      mobile_device: 'Mobile Device',
      staff_user: 'Staff User'
    };

    appBundleIds = {
      'messaging': 'com.cpctexting.chirping',
      'info': 'com.cpctexting.ChirpingInfo'
    };

    // Aligned with rows from tblEventNotificationActionTemplate
    textMessageAlertTemplateIds = {
      'Email': 1,
      'Text': 2,
      'Call': 3
    };
  break;

  case 'admin.cpctexting.com':
  case 'chirping.combinedpublic.net':
  case 'west2.admin.cpctexting.com.s3-website-us-west-2.amazonaws.com':
    apiHost = 'https://api.cpctexting.com/v3';
    socket = 'https://socket.cpctexting.com';
    inmateImportModes = { 'CPC': 'CPC' };
    featureCalling = false;
    apiCredentialSearchUserTypes = {
      inmate: 'Inmate',
      mobile_device: 'Mobile Device',
      staff_user: 'Staff User'
    };

    appBundleIds = {
      'messaging': 'com.cpctexting.chirping',
      'info': 'com.cpctexting.ChirpingInfo'
    };

    // Aligned with rows from tblEventNotificationActionTemplate
    textMessageAlertTemplateIds = {
      'Email': 1,
      'Text': 2,
      'Call': 3
    };
  break;

  case 'relcore-test.reliancetelephone.com':
  case 'west2.relcore-test.reliancetelephone.com.s3-website-us-west-2.amazonaws.com':
    apiHost = 'https://api-test.reliancetelephone.com/v3';
    socket = 'https://test.socket.reliancetelephone.com';

    // Aligned with rows from tblEventNotificationActionTemplate
    textMessageAlertTemplateIds = {
      'Email': 7,
      'Text': 8,
      'Call': 9
    };

    facilityTypes = ['reliance', 'amtel', 'demo'];
  break;

  case 'relcore-stage.reliancetelephone.com':
  case 'west2.relcore-stage.reliancetelephone.com.s3-website-us-west-2.amazonaws.com':
    apiHost = 'https://api-stage.reliancetelephone.com/v3';

    facilityTypes = ['reliance', 'amtel', 'demo'];
  break;

  case 'relcore.reliancetelephone.com':
  case 'west2.relcore.reliancetelephone.com.s3-website-us-west-2.amazonaws.com':
    facilityTypes = ['reliance', 'amtel', 'demo'];
  break;
}

if (domain !== 'localhost') {
  let domainParts = domain.split('.');
  let suffix = domainParts.pop();
  let name = domainParts.pop();
  domain = `${name}.${suffix}`;
}

const eventNotificationTemplates = {};

eventNotificationTemplates['prea_report'] = {
  name: "PREA Report",
  template: "<h2>PREA Inmate Report<h2/>\
<h1>{{ facility.name }} ({{ facility.city }}, {{ facility.state }})<h1/> \
Report timestamp: {{ variable_start_stamp|date('Y-m-d H:i') }} \
<br/>An inmate has submitted a PREA report via audio message on the Reliance \
Telephone system. The message recording is attached. The inmate was instructed to \
include any relevant details in the message including their name unless they wanted \
to remain anonymous."
}

let config:IConfig = {
  featureCalling,
  api: {
    url: apiHost,
    client: {
      id: 'relcore'
    }
  },
  connectService: {
    url: socket
  },
  eventNotification: {
    templates: eventNotificationTemplates,
    textMessageAlertTemplateIds
  },
  account: {
    invoiceFrequency: [7,14,30],
    unblockAmounts: [-0.25],
    onlineMonthlyLimits: [-150,-250,-350,-500]
  },
  inmateImportModes,
  appBundleIds,
  apiCredentialSearchUserTypes,
  facilityTypes
};

export default config;
